import React from 'react'
import Link from 'gatsby-link'

import Nav from '../components/Nav'
import Exchanges from '../components/Exchanges'

import logo from "./assets/johnnymetrics-logo-green_192px.png"
import chart from "./assets/chart.png"
import gains from "./assets/gains___losses.png"
import share from "./assets/share.png"

const IndexPage = () => (
  <div>
    <div className="hero">
      <div className="abs">
        <header aria-hidden="true">
          <section>
            <Nav />
          </section>
        </header>
        <section className="intro">
          <div className="named-logo">
            <img src={logo} />
            <h1>Johnny Metrics</h1>
          </div>
          <div className="marketing-col">
            <h3>Import your trades</h3>
            <p>Import your trades, using CSV files, or sync directly with your exchanges</p>
          </div>
          <div className="marketing-col">
            <h3>Gain insight into your portfolio</h3>
            <p>See your calculated gains and losses, and balances across all your cryptocurrency assets</p>
          </div>
          <div className="marketing-col">
            <h3 className="greenHighlight"><span>Free</span> 2 month trial</h3>
            <p>Thereafter pay $8.99/month, or yearly in Bitcoin or Litecoin</p>
          </div>
        </section>
        <div className="buttons-unit">
          <a className="button" href={`${process.env.APP_URL}/signup`}>Get Started</a>
          <a className="button" href={process.env.DEMO_ENDPOINT}>View demo</a>
        </div>
      </div>
    </div>
    <section className="lead">
      <h1>Import and analyze your crypto trades</h1>
      <p>Johnny Metrics provides the ability to upload your trades via CSV files, or sync with your exchanges using their API.<br/>We will analyze your cryptocurrency trades, and present you with simple graphs and tables to easily visualize and manage your portfolio.</p>
      <p>Now you can <strong>track your portfolio</strong>, and see how you are <i>really</i> doing.</p>
    </section>
    <section className="point1">
      <div className="prose">
        <h2>A dashboard with real-time charts</h2>
        <p>We get new prices for all of your assets every 5 minutes, so you can always visualize the current value of your portfolio. We support coins such as Bitcoin, Ethereum, Litecoin, EOS, Ripple, BitShares and thousands more.</p>
      </div>
      <div className="window">
        <img src={chart} width="350" />
      </div>
    </section>
    <div className="grayWash">
      <section className="point2">
        <div className="prose">
          <h2>Accurate profit and loss calculations</h2>
          <p>We use the FIFO method to precisely calculate your realized and unrealized gains on each of your digital coins. You can also see real-time balances of your entire portfolio.</p>
        </div>
        <div className="window">
          <img src={gains} width="350" />
        </div>
      </section>
    </div>
    <section className="point3">
      <div className="prose">
        <h2>Share your portfolio</h2>
        <p>Want to show somebody what coins are in your portfolio, and how well it is performing? Share your portfolio with anybody without disclosing any financial information.</p>
      </div>
      <div className="window">
        <img src={share} width="350" />
      </div>
    </section>
    <div id="exchanges" className="whiteWash">
      <section className="exchanges">
        <div className="prose">
          <h2>Supported API sync and CSV imports from</h2>
          <Exchanges />
        </div>
      </section>
    </div>
    <div id="pricing" className="greenWash">
      <section className="pricing">
        <div className="prose">
          <h2>Pricing</h2>
          <p>You get a <strong>2 month free</strong> trial, thereafter it is <strong>$8.99/month</strong> or $99/year paid via credit card. You can also pay yearly in Bitcoin or Litecoin if you prefer anonymity.</p>
        </div>
      </section>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js